import React from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  emoji: '😕',
  title: 'Confusión tras el diagnóstico',
  description: 'No sabes qué comer, qué evitar ni por dónde empezar tu recuperación.'
}, {
  emoji: '🍳',
  title: 'Perdido en la cocina',
  description: 'Falta de ideas para preparar comidas que sean saludables y al mismo tiempo ricas.'
}, {
  emoji: '📱',
  title: 'Información contradictoria',
  description: 'Internet está lleno de dietas extremas, mitos y consejos confusos.'
}, {
  emoji: '📉',
  title: 'Dietas fallidas',
  description: 'Has intentado regímenes estrictos y desabridos que son imposibles de mantener.'
}, {
  emoji: '🥱',
  title: 'Fatiga e hinchazón',
  description: 'Te sientes cansado todo el tiempo, sin energía y con malestar digestivo constante.'
}, {
  emoji: '😨',
  title: 'Miedo a la cirrosis',
  description: 'Preocupación constante por el avance de la enfermedad y tu futuro.'
}];
export function PainPoints() {
  return <section className="py-20 bg-brand-bg" data-id="element-113">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-115">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-116">
            ¿Tu médico te dijo "haz dieta"… pero no te explicó qué comer
            exactamente?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-117">
            Si tienes hígado graso, seguro reconoces alguna de estas
            situaciones:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-118">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-119">
              <div className="text-4xl mb-4" data-id="element-120">{point.emoji}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-121">
                {point.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-122">
                {point.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}